import { type FirmSummaryDto } from '../dto';
import { type FirmSummary } from '../models';

export function mapFirmSummaryFromDto(dto: FirmSummaryDto): FirmSummary {
  return {
    id: dto.id,
    name: dto.name,
  };
}
